import React from 'react';
import { CustomModal } from '@components/ui/modal/CustomModal';
import { CustomButton } from '@components/ui/button/CustomButton';
import Text from '@components/ui/text/Text';

interface SessionRenewalModalProps {
  isOpen: boolean;
  onLogout: () => void;
}

const BlueAlertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <circle cx="28" cy="28" r="28" fill="#007AFF" />
    <path
      d="M28 18V30"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="28" cy="38" r="2" fill="white" />
  </svg>
);

export const SessionRenewalModal: React.FC<SessionRenewalModalProps> = ({
  isOpen,
  onLogout,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      isDismissable={false}
      showHeaderDivider={false}
      showFooterDivider={false}
      classNames={{ base: 'max-w-[520px] w-full' }}
      buttons={
        <div className="flex w-full justify-end">
          <CustomButton label="Inicia sesión" onPress={onLogout} />
        </div>
      }
    >
      <div className="flex flex-col items-center gap-4 py-2 text-center">
        <BlueAlertIcon />
        <Text fontSize="subtitle-1" className="text-fg-secondary">
          ¡Evolucionamos para mejorar tu gestión!
        </Text>
        <Text fontSize="body-2" className="text-fg-tertiary">
          Para brindarte mayor seguridad y permitir que invites a otros
          administradores a este panel, hemos actualizado nuestra estructura de
          cuentas.
          <br />
          <br />
          Para activar estas nuevas funciones es necesario que inicies sesión
          nuevamente.
        </Text>
      </div>
    </CustomModal>
  );
};
